import { isEmpty } from "lodash";

import { Box } from "@/Components/v2/atoms/Box";
import { Stack } from "@/Components/v2/atoms/Stack";
import { Typography } from "@/Components/v2/atoms/Typography";
import { LegendItem, LegendItemData } from "@/Components/v2/molecule/LegendItem/LegendItem";

type LegendItemsProps = {
  legends: LegendItemData[];
  handleClick: (legendId: string) => void;
  text?: string;
};

const LegendItems = ({ legends, handleClick, text }: LegendItemsProps) =>
  !isEmpty(legends) ? (
    <Box pl={2} mt={2}>
      {text && (
        <Typography variant="body2" fontWeight={600} fontSize={14} mb={2}>
          {text}
        </Typography>
      )}
      <Stack direction="row" flexWrap="wrap" gap={1}>
        {legends.map((legend) => (
          <LegendItem
            key={legend.id}
            item={{ ...legend }}
            handleClick={() => handleClick(legend.id)}
            withBorder
          />
        ))}
      </Stack>
    </Box>
  ) : null;

export default LegendItems;
